import {EnumValueApiModel} from "./enum-value.api-model";
import {BaseDomainModel} from "../../../../infrastructure/models/base-domain-model";

export class EnumValueDomainModel extends BaseDomainModel {
  id: Number;
  value: Number;
  name: String;
  shortName: String;
  aliasName: String;

  constructor(apiModel: EnumValueApiModel) {
    super(apiModel);

    this.value = apiModel.value;
    this.name = apiModel.name;
    this.shortName = apiModel.shortName;
    this.aliasName = apiModel.aliasName;

  }

}
